/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_ResetInputs */

const en_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send password reset email. Please check your email address.`)
};

const fr_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'envoi de l'email de réinitialisation du mot de passe. Veuillez vérifier votre adresse email.`)
};

const de_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die E-Mail zum Zurücksetzen des Passworts konnte nicht gesendet werden. Bitte überprüfen Sie Ihre E-Mail-Adresse.`)
};

const it_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare l'email per reimpostare la password. Controlla il tuo indirizzo email.`)
};

const ru_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отправить письмо для сброса пароля. Пожалуйста, проверьте свой адрес электронной почты.`)
};

const es_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar el correo electrónico de restablecimiento de contraseña. Por favor, revise su dirección de correo electrónico.`)
};

const zh_cn2_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码重置邮件发送失败。请检查您的邮箱地址。`)
};

const ja_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードリセットメールを送信できませんでした。メールアドレスをご確認ください。`)
};

const hi_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड रीसेट करने के लिए ईमेल भेजने में विफलता। कृपया अपना ईमेल पता जांचें।`)
};

const pt_pt2_login_error_password_reset = /** @type {(inputs: Login_Error_Password_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao enviar o e-mail de redefinição de senha. Verifique seu endereço de e-mail.`)
};

/**
* | output |
* | --- |
* | "Failed to send password reset email. Please check your email address." |
*
* @param {Login_Error_Password_ResetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_reset = /** @type {((inputs?: Login_Error_Password_ResetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_ResetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_password_reset(inputs)
	if (locale === "de") return de_login_error_password_reset(inputs)
	if (locale === "it") return it_login_error_password_reset(inputs)
	if (locale === "ru") return ru_login_error_password_reset(inputs)
	if (locale === "es") return es_login_error_password_reset(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_password_reset(inputs)
	if (locale === "ja") return ja_login_error_password_reset(inputs)
	if (locale === "hi") return hi_login_error_password_reset(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_password_reset(inputs)
	return en_login_error_password_reset(inputs)
});